import { useEffect } from 'react';

const updateMetaTag = ({ selector, attributeName, attributeValue, content }) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attributeName, attributeValue);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
};

const updateLinkTag = ({ selector, rel, href }) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }

  element.setAttribute('href', href);
};

const PageMeta = ({ title, description, canonical, image, type = 'website', robots = 'index, follow' }) => {
  useEffect(() => {
    const fullTitle = title || 'The B Tree';
    document.title = fullTitle;

    updateMetaTag({
      selector: 'meta[name="robots"]',
      attributeName: 'name',
      attributeValue: 'robots',
      content: robots,
    });

    if (description) {
      updateMetaTag({
        selector: 'meta[name="description"]',
        attributeName: 'name',
        attributeValue: 'description',
        content: description,
      });
    }

    updateMetaTag({
      selector: 'meta[property="og:title"]',
      attributeName: 'property',
      attributeValue: 'og:title',
      content: fullTitle,
    });

    if (description) {
      updateMetaTag({
        selector: 'meta[property="og:description"]',
        attributeName: 'property',
        attributeValue: 'og:description',
        content: description,
      });
    }

    updateMetaTag({
      selector: 'meta[property="og:type"]',
      attributeName: 'property',
      attributeValue: 'og:type',
      content: type,
    });

    if (canonical) {
      updateLinkTag({ selector: 'link[rel="canonical"]', rel: 'canonical', href: canonical });
      updateMetaTag({
        selector: 'meta[property="og:url"]',
        attributeName: 'property',
        attributeValue: 'og:url',
        content: canonical,
      });
    }

    if (image) {
      updateMetaTag({
        selector: 'meta[property="og:image"]',
        attributeName: 'property',
        attributeValue: 'og:image',
        content: image,
      });
      updateMetaTag({
        selector: 'meta[name="twitter:image"]',
        attributeName: 'name',
        attributeValue: 'twitter:image',
        content: image,
      });
    }

    updateMetaTag({
      selector: 'meta[name="twitter:card"]',
      attributeName: 'name',
      attributeValue: 'twitter:card',
      content: 'summary_large_image',
    });

    updateMetaTag({
      selector: 'meta[name="twitter:title"]',
      attributeName: 'name',
      attributeValue: 'twitter:title',
      content: fullTitle,
    });

    if (description) {
      updateMetaTag({
        selector: 'meta[name="twitter:description"]',
        attributeName: 'name',
        attributeValue: 'twitter:description',
        content: description,
      });
    }
  }, [title, description, canonical, image, type, robots]);

  return null;
};

export default PageMeta;
